import { ChevronsUpDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { useAuthStore } from "./store";
import { useQueryClient } from "@tanstack/react-query";

export function TenantSwitcher() {
  const user = useAuthStore((s) => s.user);
  const activeId = useAuthStore((s) => s.activeTenantId);
  const setActiveTenant = useAuthStore((s) => s.setActiveTenant);
  const qc = useQueryClient();

  if (!user || user.tenants.length === 0) return null;

  const current =
    user.tenants.find((t) => t.tenant_id === activeId) ?? user.tenants[0];

  // Bei einem einzigen Tenant zeigt nur das Label, kein Dropdown
  if (user.tenants.length === 1) {
    return (
      <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 text-sm min-w-0">
        <span className="font-medium truncate">{current.tenant_name}</span>
        <span className="text-xs text-muted-foreground">({current.role})</span>
      </div>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2 min-w-0">
          <span className="truncate max-w-[100px] sm:max-w-[180px]">{current.tenant_name}</span>
          <span className="text-xs text-muted-foreground hidden sm:inline">{current.role}</span>
          <ChevronsUpDown className="h-3.5 w-3.5 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel>Mandanten</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {user.tenants.map((t) => (
          <DropdownMenuItem
            key={t.tenant_id}
            onSelect={() => {
              setActiveTenant(t.tenant_id);
              // Alle Queries invalidieren — anderer Tenant = andere Daten
              qc.invalidateQueries();
            }}
          >
            <div className="flex flex-1 flex-col">
              <span className="font-medium">{t.tenant_name}</span>
              <span className="text-xs text-muted-foreground">
                {t.tenant_slug} · {t.role}
              </span>
            </div>
            {t.tenant_id === activeId && (
              <span className="text-xs text-primary">aktiv</span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
